export const EMANDATE_BANK_CAPABILITY_KEYS = [
  "emandate_netbanking_enabled",
  "emandate_aadhaar_enabled",
  "emandate_debit_card_enabled",
] as const;

export const BANK_SERVICE_CAPABILITY_WARNING_KEY = {
  NETBANKING_AND_EMANDATE_NOT_SUPPORTED:
    "NETBANKING_AND_EMANDATE_NOT_SUPPORTED",
  NETBANKING_NOT_SUPPORTED: "NETBANKING_NOT_SUPPORTED",
  EMANDATE_NOT_SUPPORTED: "EMANDATE_NOT_SUPPORTED",
} as const;

export type BankServiceCapabilityWarningKey =
  (typeof BANK_SERVICE_CAPABILITY_WARNING_KEY)[keyof typeof BANK_SERVICE_CAPABILITY_WARNING_KEY];

export const BANK_SERVICE_CAPABILITY_WARNING_MESSAGES: Record<
  BankServiceCapabilityWarningKey,
  string
> = {
  [BANK_SERVICE_CAPABILITY_WARNING_KEY.NETBANKING_AND_EMANDATE_NOT_SUPPORTED]:
    "Net-banking and e-mandates are not supported",
  [BANK_SERVICE_CAPABILITY_WARNING_KEY.NETBANKING_NOT_SUPPORTED]:
    "Net-banking is not supported",
  [BANK_SERVICE_CAPABILITY_WARNING_KEY.EMANDATE_NOT_SUPPORTED]:
    "E-mandates are not supported",
};
